import { Component, Directive, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { OperationResult, NotificationService } from '../../core';
import { ConfirmModalService } from '../services/confirm-modal.service';

@Component({
	selector: 'sm-bulk-actions',
	template: require('./sm-bulk-actions.component.html')
})
export class SmBulkActionsComponent implements OnInit {
	@Input() rows: any[] = [];
	@Input() selected: any[] = [];
	@Output() onFinished: EventEmitter<BulkOperationResult> = new EventEmitter();
	@Output() onSuccess: EventEmitter<BulkOperationResult> = new EventEmitter();
	@Output() onError: EventEmitter<BulkOperationResult> = new EventEmitter();

	actions: SmBulkActionComponent[] = [];

	constructor(
		private _notificationService: NotificationService
	) { }

	register(action: SmBulkActionComponent) {
		if (!this.actions) {
			this.actions = [];
		}
		this.actions.push(action);
	}

	fireOnFinished(result: BulkOperationResult) {
		if (result.success) {
			this.onSuccess.emit(result);
			if (result.message.indexOf('href=') > -1) {
				this._notificationService.info(result.message);
			}
			else {
				this._notificationService.success(result.message);
			}
		}
		else {
			this.onError.emit(result);
			this._notificationService.error(result.message);
		}

		if (this.onFinished.observers.length) {
			this.onFinished.emit(result);
		}
	}

	ngOnInit() { }
}

export abstract class SmBulkActionComponent implements OnInit {
	@Input() name: string;
	@Input() title: string;
	@Input() minSelected: number = 1;
	@Input() cssClass: string = 'btn btn-secondary';

	constructor(protected container: SmBulkActionsComponent) { }

	get disabled() {
		return this.container.selected.length < this.minSelected;
	}

	get hidden() {
		return false;
	}

	abstract onClick(): void;

	ngOnInit() {
		this.container.register(this);
	}
}

@Directive({ selector: 'sm-link-bulk-action' })
export class SmLinkBulkActionComponent extends SmBulkActionComponent {
	@Input() url: string;

	constructor(
		container: SmBulkActionsComponent,
		private _router: Router,
		private _modal: ConfirmModalService
	) {
		super(container);
	}

	onClick(): void {
		this._router.navigateByUrl(this.url);
	}
}

export interface BulkOperationResult extends OperationResult {
	bulkOperationType: BulkOperationType;
}

export enum BulkOperationType {
	Unspecified = 0,
	ChangePricelist = 1,
	CopyToTemplate = 2,
	FinishOffer = 3,
	ChangeTemplate = 10,
	ChangeOfferType = 11,
	CopyTemplate = 12,
	DeleteTemplate = 13,
	ExposeAgain = 14,
	Expose = 15,
	FinishOfferForTemplate = 16,
	ImportTemplate = 17,
	MoveTemplate = 18,
	CloseTransaction = 20,
	Feedback = 21,
	Group = 22,
	MoveTransaction = 23,
	SendRefund = 24,
	SendEmail = 25,
	Split = 26,
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-bulk-actions.component.ts